import { render, staticRenderFns } from "./plansSmallBtn.vue?vue&type=template&id=5fb100a0"
import script from "./plansSmallBtn.vue?vue&type=script&lang=js"
export * from "./plansSmallBtn.vue?vue&type=script&lang=js"
import style0 from "./plansSmallBtn.vue?vue&type=style&index=0&id=5fb100a0&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports